export const faqQuestion=(id)=>`/v2/faqs/${id}`;
export const faq_categories=`/v2/faq-categories`;
export const filterQuestion=`/v2/faq-by-questions`;
